const translations = { title: 'Configurações de níveis de locais' }

export default translations
